
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contributions",
      function () {
        return require("private-next-pages/contributions/index.tsx");
      }
    ]);
  